export interface AzureAdConfig {
  clientId: string;
  tenantId: string;
}

export const features = {
  permissions: import.meta.env.VITE_FEATURE_PERMISSIONS === "true",
  previewFeatures: import.meta.env.VITE_PREVIEW_FEATURES !== "false",
} as const;

export const AUTH_BYPASS: boolean = import.meta.env.VITE_AUTH_BYPASS === "true";

export interface AnalyticsConfig {
  host: string | null;
  key: string | null;
  environment: string;
}

export const analyticsConfig: AnalyticsConfig = {
  host: import.meta.env.VITE_ANALYTICS_HOST || null,
  key: import.meta.env.VITE_ANALYTICS_KEY || null,
  environment: import.meta.env.VITE_ANALYTICS_ENVIRONMENT || import.meta.env.MODE,
};

export const getAzureAdConfig = (): AzureAdConfig => {
  const clientId = import.meta.env.VITE_AZURE_CLIENT_ID;
  const tenantId = import.meta.env.VITE_AZURE_TENANT_ID || "e3b48527-4cbe-42a2-b4d2-11b3cc7a86fc";

  if (!clientId && !AUTH_BYPASS) {
    throw new Error("VITE_AZURE_CLIENT_ID environment variable is not set");
  }

  return {
    clientId: clientId ?? "00000000-0000-0000-0000-000000000000",
    tenantId,
  };
};
